import * as yup from "yup";
import { useTranslation } from "react-i18next";
import BaseForm from "../../../../../../../shared/components/form/BaseForm";
import FormInput from "../../../../../../../shared/components/input/FormInput";
import FormSelect from "../../../../../../../shared/components/select/FormSelect";

const UpdatePlatformClientMappingForm = ({
  platformMapping,
  platforms,
  onSubmitHandler,
}) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    platform: yup
      .string()
      .required(
        t(
          "clients.detail.tabs.platformMappings.updateForm.fields.platform.required",
        ),
      ),
    code: yup
      .string()
      .required(
        t(
          "clients.detail.tabs.platformMappings.updateForm.fields.code.required",
        ),
      ),
  });

  const defaultValues = {
    platform: platformMapping?.platform?.id,
    code: platformMapping?.code,
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
      isCreationForm={false}
    >
      <FormSelect
        name="platform"
        label={t(
          "clients.detail.tabs.platformMappings.updateForm.fields.platform.label",
        )}
        options={platforms}
        required
      />
      <FormInput
        name="code"
        label={t(
          "clients.detail.tabs.platformMappings.updateForm.fields.code.label",
        )}
        required
      />
    </BaseForm>
  );
};

export default UpdatePlatformClientMappingForm;
